// frontend/src/components/ProductsPage.js

import React, { useState, useEffect } from 'react';
// Import Modal, Image, and other components from react-bootstrap
import { Container, Row, Col, Card, Nav, Button, Modal, Image } from 'react-bootstrap'; 
import axios from 'axios'; 

// ----------------------------------------------------------------------
// 1. DUMMY PRODUCT DATA 
// ----------------------------------------------------------------------
const dummyProducts = [
  { 
    id: 100, 
    name: ' H1-PRO LARGE FORMAT INKJET PRINTER', 
    brand: 'H1-PRO', // Brand Name
    description: 'The H1-PRO is an industrial digital textile printer designed for high-speed and high-definition fabric printing.', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Models</td><td>H1-PRO-K32,H1-PRO-K16</td></tr>
          <tr><td>Key Specifications</td><td>Maximum Printing Width: 1800 mm,Printhead: Kyocera EX600RC,Ink Types Supported: Reactive, Disperse, Acid, Pigment,Applicable Materials: Cotton, Linen, Silk, Wool, Polyester, Nylon, Blended fabrics</td></tr>
          <tr><td>Printhead Configuration</td><td>K32: 32 heads / 8 colors (4×8),K16: 16 heads / 8 colors (4×4)</td></tr>
          <tr><td>Production Speed (m²/hour),H1-PRO-K32</td><td>1 Pass: 1188 (HD) | 1287 (High Speed), 2 Pass: 594 (HD) | 644 (High Speed), 4 Pass: 297 (HD) | 322 (High Speed)</td></tr>
          <tr><td>Production Speed (m²/hour),H1-PRO-K16</td><td>2 Pass: 660 (HD) | 700 (High Speed),4 Pass: 330 (HD) | 350 (High Speed)</td></tr>
          <tr><td>Power & Physical Specs</td><td>Power Supply: 3-Phase 380VAC, 20 kW,Machine Size (L×W×H): 3100 × 5100 × 2120 mm,Weight: 6000 kg</td></tr>
        </tbody>
      </table>`,
    image: '/images/Digital mechine/Model_H1-PRO.png', // Placeholder image path
    category: 'DIRECT TEXTILE PRINTING'
  },
  { 
    id: 102, 
    name: 'Q1 LARGE FORMAT INKJET PRINTER', 
    brand: 'Q1', // Brand Name
    description: 'The Hopetech Q1 large format inkjet printer is an industrial-grade, high-speed digital textile printer designed for printing vibrant designs on a variety of fabrics and materials.', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>Q1-K8,	Q1-K24,	Q1-M24</td></tr>
          <tr><td>Max Printing Width</td><td>1900mm</td></tr>
          <tr><td>Printhead Brand/Type</td><td>Kyocera KJ4B-0600/KJ4B-0300,Epson S3200</td></tr>
          <tr><td>Ink Type</td><td>Reactive/Disperse/Acid/Pigment</td></tr>
          <tr><td>Applicable Medium</td><td>Cotton, Linen, Silk, Wool, Polyester, Nylon, Blended Materials, Transfer Paper</td></tr>
          <tr><td>Power Supply</td><td>380VAC, 10kW 3Phase 380VAC, 10kW</td></tr>
          <tr><td>Printer Dimension(LxWxH)</td><td>2500×4450×1850mm</td></tr>
          <tr><td>Printer Weight</td><td>2900kg/td></tr>
        </tbody>
      </table>`,
    image: '/images/Digital mechine/Model_Q1.jpg', 
    category: 'DIRECT TEXTILE PRINTING'
  },
  { 
    id: 103, 
    name: 'HF01 LARGE FORMAT INKJET PRINTER', 
    brand: 'HF01', // Brand Name
    description: 'the Hopetech HF01 large format inkjet printer, a multi-pass industrial digital printer designed for textile applications', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Manufacturer: </td><td>Hopetech Digital Co., Ltd.</td></tr>
          <tr><td>Max Printing Width</td><td>1900mm</td></tr>
          <tr><td>Printer Type:</td><td>Large format, multi-pass textile digital printer. It is mentioned alongside models like the Q1, HF02, and HF03 in product listings.</td></tr>
          <tr><td>Applicable Medium</td><td>It is suitable for various applications in the home textile market, including towels, silk scarves, curtains, wall fabric, and wallpaper.</td></tr>
        </tbody>
      </table>`,
    image: '/images/Digital mechine/HF01.jpg', 
    category: 'DIRECT TEXTILE PRINTING'
  },

  {  
    id: 104, 
      name: 'HF02  LARGE FORMAT INKJET PRINTER', 
      brand: 'HF02', // Brand Name
      description: 'Industrial printers of this scale typically require a 3-phase power supply, commonly 380VAC, with power consumption around 10kW for the main printer unit and a separate supply for the dryer unit..', 
      fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>HF02</td></tr>
          <tr><td>Max Printing Width</td><td>Up to 1900 mm (75 inches), as it shares media compatibility with other large format models from the manufacturer.</td></tr>

          <tr><td>Printhead Brand/Type</td><td>Hopetech industrial printers often use Kyocera or Epson printheads. The HF02 model is typically mentioned as having a large number of heads, such as 32, 48, or 64 heads.</td></tr>

          <tr><td>Printhead Color</td><td>The number of colors depends on the configuration, but most industrial models support standard CMYK plus additional colors (e.g., orange, blue, red, gray) for expanded gamut, often running in an 8-color mode.</td></tr>
          <tr><td>Printing Mode</td><td>It is a multi-pass, scanning inkjet printer designed for direct-to-fabric printing. Specific modes would include variations of High Definition and High Speed passes.</td></tr>
          <tr><td>Ink Type</td><td>It is compatible with a range of inks for different fabrics: Reactive, Disperse, Acid, and Pigment inks.</td></tr>
          <tr><td>Applicable Medium</td><td>Cotton, Linen, Silk, Wool, Polyester, Nylon, Blended Materials, Transfer Paper</td></tr>
          <tr><td>Power Supply</td><td>Industrial printers of this scale typically require a 3-phase power supply, commonly 380VAC, with power consumption around 10kW for the main printer unit and a separate supply for the dryer unit.</td></tr>
        </tbody>
      </table>`,
      image: '/images/Digital mechine/HF02 Scanning Textile Digital Printing Machine.png', 
      category: 'DIRECT TEXTILE PRINTING'
    },
   {  
    id: 105, 
      name: 'TS1600  LARGE FORMAT INKJET PRINTER', 
      brand: 'TS1600', // Brand Name
      description: 'The manufacturer, Hopetech, uses printheads from various brands for their industrial lines, which may include Kyocera, Epson, or Heidelberg print heads in this model.', 
      fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>TS1600</td></tr>
          <tr><td>Max Printing Width</td><td>Max 1600 mm (approximately 63 inches)</td></tr>

          <tr><td>Printhead Brand/Type</td><td>The manufacturer, Hopetech, uses printheads from various brands for their industrial lines, which may include Kyocera, Epson, or Heidelberg print heads in this model.</td></tr>

          <tr><td>Printhead Color</td><td>The number of colors can go up to 12 color bars for expanded gamut or specialty printing, but the exact configuration depends on the user's setup.</td></tr>
          <tr><td>Printing Mode</td><td>Single-pass high-speed digital printing.</td></tr>
          <tr><td>Ink Type</td><td>It is versatile and can use Reactive, Disperse, Acid, or Pigment inks, depending on the application and fabric type.</td></tr>
          <tr><td>Power Supply</td><td>3-phase 380VAC, 40kW power consumption.</td></tr>
        </tbody>
      </table>`,
      image: '/images/Digital mechine/TS1600 Single-pass Digital Printing Machine.jpg', 
      category: 'DIRECT TEXTILE PRINTING'
    },
   { 
    id: 201, 
    name: 'G1-PRO LARGE FORMAT INKJET PRINTER', 
    brand: 'G1-PRO', // Brand Name
    description: '12 years of Industrial Digital Inkjet Printing Experience Thousands of Printheads On Site Stable Production', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>G1-PRO (Various configurations like G1-PRO-K12, G1-PRO-M12, G1-PRO-M16).</td></tr>
          <tr><td>Max Printing Width</td><td>Max 1900mm (1.9 meters).</td></tr>

          <tr><td>Printhead Brand/Type</td><td>Epson S3200 or Kyocera EX600RC (depending on configuration).</td></tr>

          <tr><td>Printhead Color</td><td>Configurable for 4 Colors (CMYK) or 6 Colors (CMYK Lc Lm).</td></tr>
          <tr><td>Printing Mode</td><td>High Definition Mode & High Speed Mode.</td></tr>
          <tr><td>Ink Type</td><td>Sublimation, AQ Pigment, or Reactive inks (depending on setup).</td></tr>
          <tr><td>Power Supply</td><td>3Phase 380VAC, 18KW. </td></tr>
        </tbody>
      </table>`,
    image: '/images/Sublimation/G1-PRO High Speed Sublimation Digital Printing Machine.jpg', 
    category: 'SUBLIMATION'
   },
    { 
      id: 202, 
      name: 'G1 LARGE FORMAT INKJET PRINTER', 
      brand: 'G1', // Brand Name
      description: 'The printer supports different modes based on speed and resolution, typically High Definition Mode and High Speed Mode. The printing method is generally roll-to-roll.', 
      fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>G1 series (includes models such as G1-M8, G1-K12, G1-PRO-M24, G1-PRO-I32, etc.).</td></tr>
          <tr><td>Max Printing Width</td><td>The maximum printing width is generally 1900 mm (1.9m). A G1 model with 1860 mm width is also mentioned in some sources.</td></tr>

          <tr><td>Printhead Brand/Type</td><td>The printer uses different brands and types of printheads, including Epson S3200, Epson I3200, Kyocera EX600RC, and Fujifilm Dimatix.</td></tr>

          <tr><td>Printhead Color</td><td>The quantity and color configuration depend on the specific model, with options such as:8 Heads / 4 Colors (2x4 configuration),12 Heads / 6 Colors (2x6 configuration),12 Heads / 4 Colors (3x4 configuration),16 Heads / 4 Colors (2x8 configuration),24 Heads / 4 Colors (4x6 or 4x12 configuration),32 Heads / 4 Colors (2x16 configuration)</td></tr>
          <tr><td>Printing Mode</td><td>The printer supports different modes based on speed and resolution, typically High Definition Mode and High Speed Mode. The printing method is generally roll-to-roll.</td></tr>
          <tr><td>Ink Type</td><td>The compatible ink types include sublimation, AQ pigment, and reactive inks.</td></tr>
          <tr><td>Power Supply</td><td>The standard power supply is 3 Phase, 380 VAC, 18 KW.  </td></tr>
        </tbody>
      </table>`,
      image: '/images/Sublimation/G1 high-speed sublimation digital printing machine.jpg', 
      category: 'SUBLIMATION'
    },
    { 
      id: 203, 
      name: 'G2 LARGE FORMAT INKJET PRINTER', 
      brand: 'G2', // Brand Name
      description: 'The G2 large format inkjet printer has a maximum printing width of 2600mm and uses either Kyocera EX600RC or Epson S3200 printheads to deliver 4-color printing with various ink types. ', 
      fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>G2-K8 or G1-M8</td></tr>
          <tr><td>Max Printing Width</td><td>2600 mm max</td></tr>

          <tr><td>Printhead Brand/Type</td><td>Kyocera EX600RC or Epson S3200</td></tr>

          <tr><td>Printhead Color</td><td>4 Colors (using 8 heads, configured as 2x4 colors)</td></tr>
          <tr><td>Printing Mode</td><td>High Definition Mode and High Speed Mode are available production settings.</td></tr>
          <tr><td>Ink Type</td><td>Compatible with Thermal Sublimation, Water-Based Pigments, and Active inks.</td></tr>
          <tr><td>Power Supply</td><td> 3 Phase 380 VAC, 18 KW  </td></tr>
        </tbody>
      </table>`,
      image: '/images/Sublimation/G2 high-speed sublimation digital printing machine.jpg', 
      category: 'SUBLIMATION'
    },
  { 
    id: 204, 
    name: 'G3 Pro LARGE FORMAT INKJET PRINTER', 
    brand: 'G3 Pro', // Brand Name
    description: 'Perform well with high speed take-up roller systems for long, unattended production runs. Ensures an extraordinary level of print durability even in one pass printing.Vibrant and intense color and sharp image with excellent color fastness.Produce quick-drying graphic on thin coated paper.Comply with OEKO-TEX ECO PASSPORT standard, eco-friendly.', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Machine Model</td><td>G3-PRO-K12 Model</td></tr>
          <tr><td>Max Printing Width</td><td>Max 3250mm</td></tr>

          <tr><td>Printhead Brand/Type</td><td>Kyocera EX600RC</td></tr>

          <tr><td>Printhead Color</td><td>4 Colors (12 heads, 3*4 configuration)</td></tr>
          <tr><td>Printing Mode</td><td>High Definition Mode</td></tr>
          <tr><td>Ink Type</td><td>Thermal Sublimation or Water-Based Pigments</td></tr>
          <tr><td>Power Supply</td><td> 380VAC, 28kW (3 phase) </td></tr>
        </tbody>
      </table>`,
    image: '/images/Sublimation/G3-PRO high-speed sublimation digital printing machine.png', 
    category: 'SUBLIMATION'
  },
  { 
    id: 301, 
    name: 'Dye-sublimation-ink', 
    brand: 'Dye-sublimation-ink', // Brand Name
    description: 'Dye-sublimation ink is a special dye that turns from solid to gas under high heat and pressure, bonding directly into polyester fibers or polymer coatings on items like t-shirts, mugs, and signs for vivid, permanent prints. ', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Process:</td><td>Ink is printed onto transfer paper, then heat-pressed onto a polyester or polymer-coated product, turning the dye into a gas that permeates the material.</td></tr>
          <tr><td>Vibrancy & Durability: </td><td>Produces bright, photo-quality colors with excellent fastness, resisting fading from washing or light.</td></tr>

          <tr><td>Application:</td><td> Ideal for textiles (polyester), ceramics, metal, and plastics, especially light-colored items.</td></tr>

          <tr><td>Ink Type: </td><td>Contains solid dye particles in a liquid carrier (often water-based or solvent-based).</td></tr>
          <tr><td>Requirements:</td><td>Needs specific sublimation printers and heat presses (around 350-400°F/175-200°C). </td></tr>
        </tbody>
      </table>`,
    image: '/images/DIGITAL PRINTING INK/Dye Sublimation Ink.jpg', 
    category: 'DIGITAL PRINTING INK'
  },
  { 
    id: 302, 
    name: 'Acid-ink', 
    brand: 'acid-ink', // Brand Name
    description: '"Acid ink" (or acid dye ink) is a type of water-based ink used primarily for digital textile printing on specific materials, especially protein-based fibers like silk, wool, and leather, as well as synthetic polyamides (nylon, Lycra).', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Vibrant Colors:</td><td>Acid inks are known for producing exceptionally bright, vivid, and saturated colors with a wide color gamut.</td></tr>
          <tr><td>Target Fabrics: </td><td>They are specifically designed for materials that do not retain color easily with other dye types. The "acid" in the name refers to the acidic environment required to bond the dye effectively with the fiber's chemical structure, forming strong ionic bonds.</td></tr>

          <tr><td>Durability (Fastness):</td><td> These inks offer excellent colorfastness, including high resistance to washing, light, sweat, chlorine, and saltwater, making them ideal for demanding applications like swimwear, sportswear, and high-end fashion.</td></tr>

          <tr><td>Aesthetics: </td><td>They are prized for achieving deep penetration into the fabric, creating prints that are visible on both the front and reverse sides of the material, which is desirable for items like scarves. </td></tr>
        </tbody>
      </table>`,
    image: '/images/DIGITAL PRINTING INK/acid-ink.jpg', 
    category: 'DIGITAL PRINTING INK'
  },
  { 
    id: 303, 
    name: 'Disperse-ink', 
    brand: 'Disperse-ink', // Brand Name
    description: 'Disperse ink is a specialized, water-insoluble ink for printing on synthetic fabrics like polyester, activated by high heat to turn into a gas, penetrate the fibers, and become a permanent, durable color once cooled.', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Hydrophobic Nature:</td><td> Poorly soluble in water, designed for hydrophobic (water-repelling) synthetic materials.</td></tr>
          <tr><td>Heat-Activated: </td><td>Requires high temperatures (e.g., 210°C) for the dye to vaporize and bond with polyester fibers.</td></tr>

          <tr><td>Low Aggregation: </td><td>  Formulated with dispersants to keep dye particles stable, preventing clogging in printheads.</td></tr>

          <tr><td>Durability:  </td><td>Offers superior resistance to fading (lightfastness), washing, perspiration, and abrasion.  </td></tr>
        </tbody>
      </table>`,
    image: '/images/DIGITAL PRINTING INK/Disperse-ink.jpg', 
    category: 'DIGITAL PRINTING INK'
  },

  { 
    id: 304, 
    name: 'Pigment-ink', 
    brand: 'Pigment-ink', // Brand Name
    description: 'Pigment ink is a type of printing ink that uses tiny, solid color particles suspended in a liquid carrier. ', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Composition:</td><td> Pigment ink consists of solid, opaque particles (pigments) suspended in a liquid medium, often water-based, along with binders and additives.</td></tr>
          <tr><td>Mechanism:</td><td>The solid particles adhere to the surface of the substrate (e.g., paper or fabric) rather than being absorbed into its fibers.</td></tr>

          <tr><td>Drying Time:  </td><td> It generally has a slower drying time compared to dye inks, as the liquid carrier must evaporate and the particles must adhere to the surface.</td></tr>
        </tbody>
      </table>`,
    image: '/images/DIGITAL PRINTING INK/pigment-ink.jpg', 
    category: 'DIGITAL PRINTING INK'
  },

  { 
    id: 305, 
    name: 'Reactive-ink', 
    brand: 'Reactive-ink', // Brand Name
    description: 'Reactive ink is a type of dye-based ink that forms a permanent chemical bond with the fibers of natural materials, most notably cotton, linen, silk, and wool.', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Substrate Compatibility: </td><td> Primarily used on natural fibers.</td></tr>
          <tr><td>Bonding Mechanism: </td><td>The dye molecules in the ink react with the cellulose or protein in the fabric to form a strong covalent bond, ensuring the color does not wash out easily.</td></tr>

          <tr><td>Color Quality: </td><td> Known for producing bright, saturated colors with a wide gamut and a soft feel on the fabric.</td></tr>
           <tr><td>Durability:</td><td> Offers excellent resistance to fading, washing, light exposure, and rubbing (crock fastness). </td></tr>
        </tbody>
      </table>`,
    image: '/images/DIGITAL PRINTING INK/Reactive-ink.jpg', 
    category: 'DIGITAL PRINTING INK'
  },

  { 
    id: 401, 
    name: 'Reactive digital printing thickener', 
    brand: 'Reactive digital printing thickener', // Brand Name
    description: 'Reactive digital printing thickener',
    fullDescription: `<h3>Key Specifications:</h3>
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>SKILLFUL® YPM-25</td><td>Dosage 3-4%,200-400mPa•s,(4%Brookfield viscometer/25℃/20rpm),Anion/nonionic.<br><br>It is used for cellulose fiber fabrics, which can effectively prevent color change, effectively improve the color yield, color vividness and color uniformity of reactive dye digital printing, so that the clarity of the fabric pattern and color depth can be optimal. This product is ZDHC Level 3 certified.</td></tr>

          <tr><td>SKILLFUL® WP-5N </td><td>Dosage 3-4%,pH 9.0-12.0,Anion/nonionic,1800mm<br><br>Online coating thickener, with good mesh passing and water holding properties; Make the digital printed fabric have a clear pattern, high color, bright color, and good hand feel. This product complies with the requirements of the EU REACH environmental protection regulation.</td></tr>
          <tr><td>SKILLFUL® PC-130</td><td>Dosage 3%,400-700mPa•s,(3%Brookfield viscometer/25℃/20rpm)Anion/nonionic.<br><br>It is used for reactive digital print, with good hand feel, high color yield, bright color, and good printing effect. This product complies with the requirements of the EU REACH environmental regulation. This product is ZDHC Level 3 certified.</td></tr>
        </tbody>
      </table>`,
    image: '/images/chemical/FIXING AGENT -ECT.png', 
    category: 'CHEMICAL'
  },
    { 
    id: 402, 
    name: 'Acid digital printing thickener', 
    brand: 'SKILLFUL® PL-500', // Brand Name
    description: '',
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>SKILLFUL® PL-500</td><td>Dosage 5%,pH 4.0-6.0,Anion/nonionic.<br><br>It is used for padding on the stenter machine and rotary screen machine, which is convenient for padding and can effectively improve the color yield, color vividness and color uniformity of acid dye digital printing. This product complies with the requirements of the EU REACH environmental protection regulation and has passed the ZDHC Level 3 certification.</td></tr>
        </tbody>
      </table>`,
    image: '/images/chemical/SKILLFUL FC.jpg', 
    category: 'CHEMICAL'
  },
  { 
    id: 403, 
    name: 'Disperse Digital printing thickener', 
    brand: 'SKILLFUL® PT-5N', // Brand Name
    description: '',
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>SKILLFUL® PT-5N</td><td>Dosage 4-6%,Anion/nonionic.<br><br>Disperse digital printing thickener for polyester fabrics can effectively improve the color yield, color vividness and color uniformity, so that the clarity of the pattern and the depth of color can achieve the best match.</td></tr>
        </tbody>
      </table>`,
    image: '/images/chemical/SKILLFUL FC.jpg', 
    category: 'CHEMICAL'
  },
   { 
    id: 404, 
    name: 'Reactive digital printing auxiliaries', 
    brand: 'SKILLFUL® 136', // Brand Name
    description: '',
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>SKILLFUL® 136</td><td>Dosage 4-6%,Anion/nonionic.<br><br>The multi-functional moisture absorption for reactive digital printing is our company's high-tech environmental protection products combined with chemical products in the current sewage discharge of printing and dyeing enterprises, and the newly developed high-tech environmental protection products combined with special polymer compounds and chemical products, which replace urea in the printing process, suitable for environmental protection, good hygroscopicity, and can make the color of the printing effect good.This product complies with the requirements of the EU REACH environmental regulation and does not contain APEO.</td></tr>

           <tr><td>SKILLFUL® JEP</td><td>Nonionic, liquid<br><br>Used for reactive digital printing substrate, the penetrant with high wetting and degreasing and defoaming functions can help the substrate be evenly distributed on the fabric, promote the dissolution and penetration of ink, and ultimately improve the uniformity and penetration effect of digital printing fabrics.This product does not contain APEO</td></tr>
        </tbody>
      </table>`,
    image: '/images/chemical/SKILLFUL 136.jpg', 
    category: 'CHEMICAL'
  },
   { 
    id: 405, 
    name: 'DYEING PRE-TREATMENT AUXILIARIES', 
    brand: 'SKILLFUL® 2602', // Brand Name
    description: '',
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>SKILLFUL® 2602</td><td>Multifunctional scouring agent,Anion/nonionic, liquid<br><br>It is used for pure cotton and its blended terry cloth intermittent and cold pad batch  pretreatment processing. Multi-functional environmental protection additive, with alkali agent, hydrogen peroxide stabilizer, penetrant and chelating agent and other functions.</td></tr>
        </tbody>
      </table>`,
    image: '/images/chemical/SCOURING AGENT 2602.jpg', 
    category: 'CHEMICAL'
  },
  { 
    id: 501, 
    name: 'CONVEAR FELT', 
    brand: 'CONVEAR FELT', // Brand Name
    description: 'Conveyor felt belts are specialized, non-woven belts used for gentle, protective, and efficient material handling in industries like electronics, automotive, and printing', 
    fullDescription: `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Surface Protection: </td><td> Soft surface prevents scratches, ideal for delicate goods.</td></tr>
          <tr><td>Heat Resistance:</td><td>Withstands high temperatures in ceramics, glass, and foundry work.</td></tr>

          <tr><td>Abrasion & Cut Resistance: </td><td>  Durable for cutting machines (CNC, paper).</td></tr>

          <tr><td>Air Permeability:  </td><td> Helps with vacuum hold-down in cutting tables (wind absorption).</td></tr>
          <tr><td>Flexibility & Stability:  </td><td> Low stretch, good grip, and stable movement.</td></tr>
          <tr><td>Anti-Static: </td><td>  Prevents static buildup in electronics. </td></tr>
        </tbody>
      </table>`,
    image: '/images/ACCESSORIRS/CONVEAR FELT-1.jpg', 
    category: 'ACCESSORIRS'
  },
    { 
    id: 502, 
    name: 'FELT', 
    brand: 'FELT-2', // Brand Name
    description: 'Felt is a versatile, non-woven textile made by matting, condensing, and pressing fibers together using a combination of heat, moisture, and pressure. Unlike most fabrics that are woven or knitted, felt does not fray or unravel when cut, which makes it popular for various applications.', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Arts and Crafts: </td><td> Widely used for doll making, scrapbooking, and children's projects because it does not fray and is easy to cut and handle.</td></tr>
          <tr><td>Apparel and Home Decor:</td><td>Used for making hats (which is the origin of the phrase "mad as a hatter" due to mercury use in historical felt processing), slippers, coats, table runners, and rugs.</td></tr>

          <tr><td>Industrial Applications: </td><td>   Valued for its ability to dampen sound and vibration, absorb fluid, and resist wear. It is used as insulation in cars and construction, for gaskets</td></tr>

          <tr><td>Air Permeability:  </td><td> Helps with vacuum hold-down in cutting tables (wind absorption).</td></tr>
          <tr><td>Flexibility & Stability:  </td><td> Low stretch, good grip, and stable movement.</td></tr>
          <tr><td>Anti-Static: </td><td>  Prevents static buildup in electronics. </td></tr>
        </tbody>
      </table>`,
    image: '/images/ACCESSORIRS/FELT-2.jpg', 
    category: 'ACCESSORIRS'
  },
   { 
    id: 503, 
    name: 'Heat transfer printing Felt', 
    brand: 'Heat transfer printing Felt', // Brand Name
    description: 'Heat transfer printing felt blanket is made of high temperature resistant Nomex(Aramid) fiber, the middle base cloth adopts endless cylinder base cloth, it is the special felt for digital and heat transfer printing machines to printing all kinds of fabrics, curtain cloth, mouse pads,etc.', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Advantages: </td><td>  Clear printing patterns,bright colors Even,smooth and fine felt surface,Stable dimension,no deformation, Good heat resistance,Good elasticity.</td></tr>
        </tbody>
      </table>`,
    image: '/images/ACCESSORIRS/Heat Felt.jpg', 
    category: 'ACCESSORIRS'
  },
 { 
    id: 504, 
    name: 'Calender Felt:', 
    brand: 'Calender Felt:', // Brand Name
    description: 'Calender Felt are used on the Calender Machines to finishing, Ironing, softening of the fabrics. Calender Machines are used in woven fabrics finishing plants.', 
    fullDescription:  `
      <table class="table table-bordered table-striped">
        <thead>
        </thead>
        <tbody>
          <tr><td>Advantages: </td><td> Even and smooth felt surface, Stable running, no runaway, Stable dimension,no deformation, Good wear-resistance.</td></tr>
        </tbody>
      </table>`,
    image: '/images/ACCESSORIRS/Calender Felt.jpg', 
    category: 'ACCESSORIRS'
  },
  { 
    id: 601, 
    name: 'neoStampa Delta', 
    brand: 'neoStampa Delta', // Brand Name
    description: 'Smart Color Management for Smarter Printing', 
    fullDescription: 'Compatible with all major brands of printers on the market, neoStampa has a user-friendly interface and is straightforward to use, offering advanced technology for image processing.  This RIP Software have a powerful color management engine and multiple options for cost control, image editing, calibration and print profiling make neoStampa the best available solution.',
    image: '/images/software/Different-printers-same-color.png', 
    category: 'SOFTWARE'
  },
  
];

const allCategories = ['ALL CATEGORIES', ...new Set(dummyProducts.map(p => p.category))];

// ----------------------------------------------------------------------
// 2. PRODUCTSPAGE COMPONENT
// ----------------------------------------------------------------------
const ProductsPage = () => {
  const [products, setProducts] = useState(dummyProducts);
  const [activeCategory, setActiveCategory] = useState('ALL CATEGORIES'); 
  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleReadMore = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedProduct(null); 
  };

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
  };

  const filteredProducts = activeCategory === 'ALL CATEGORIES'
    ? products
    : products.filter(product => product.category === activeCategory);


  // ----------------------------------------------------------------------
  // 3. PRODUCT MODAL COMPONENT (Custom Close Button Implemented)
  // ----------------------------------------------------------------------
  const ProductModal = () => (
    <Modal show={showModal} onHide={handleClose} size="lg" centered>
      {/* ACTION: Removed 'closeButton' prop. Using 'text-white' on header 
        for the title text color.
      */}
      <Modal.Header className="bg-dark">
        <Modal.Title className="font-weight-bold text-white">{selectedProduct?.name}</Modal.Title>
        
        {/* CUSTOM CLOSE BUTTON: Manually added a button with inline styles to 
          force the 'X' to be white and visible, overriding any CSS conflicts.
        */}
        <button 
          type="button" 
          aria-label="Close" 
          onClick={handleClose} 
          style={{ 
              // Key fix: Force the color and opacity
              color: 'white', 
              opacity: '1',   
              // Styling to make it look and function correctly as a close button
              fontSize: '1.5rem', 
              fontWeight: '700',
              lineHeight: '1',
              background: 'none', 
              border: 'none',
              // Bootstrap 4/5 positioning utility:
              // Simulates the positioning of the original close button
              position: 'absolute', 
              right: '1rem', 
              top: '50%',
              transform: 'translateY(-50%)',
          }}
        >
          {/* HTML entity for multiplication sign, used as the 'X' close icon */}
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      
      <Modal.Body>
        <Row>
          {/* Left Side: Product Image and Brand Name */}
          <Col md={5} className="mb-3 mb-md-0">
            <Image 
              src={selectedProduct?.image} 
              alt={selectedProduct?.name} 
              fluid 
              rounded 
              className="shadow-sm"
            />
             {/* New: Dedicated Brand Name Block */}
             <div className="mt-3 p-3 text-center bg-info text-white rounded shadow-sm">
                <p className="mb-0">Model:</p>
                <h4 className="font-weight-bold mb-0">{selectedProduct?.brand}</h4>
            </div>
          </Col>
          {/* Right Side: Full Description and Details */}
          <Col md={7}>
            <h4 className="text-secondary">Product Details</h4>
            <p className="lead text-justify">{selectedProduct?.description}</p>
            <hr/>
            <h5 className="text-primary">In-Depth Description</h5>
            
            {/* **CHANGE: Use dangerouslySetInnerHTML to render the HTML table** */}
            <div 
              className="text-justify"
              dangerouslySetInnerHTML={{ __html: selectedProduct?.fullDescription }}
            ></div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );


  // ----------------------------------------------------------------------
  // 4. MAIN RENDER
  // ----------------------------------------------------------------------
  return (
    <>
      {/* 1. Header/Banner Section */}
      <div style={{ backgroundColor: '#212529', color: '#fff' }} className="py-5 text-center">
        <Container>
          <h1 className="display-4 font-weight-bold mb-3">Our Textile Product Range</h1> 
          <p className="lead text-muted">Explore high-quality and trusted textile solutions.</p>
        </Container>
      </div>

      {/* 2. Category Navigation Tabs */}
      <Container className="my-5">
        <Nav variant="pills" className="flex-wrap justify-content-center mb-5">
          {allCategories.map(category => (
            <Nav.Item key={category} className="mx-1 mb-2">
              <Nav.Link 
                eventKey={category} 
                active={activeCategory === category}
                onClick={() => handleCategoryClick(category)}
                className="text-uppercase"
                style={{ cursor: 'pointer' }}
              >
                {category}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        {/* 3. Product Grid */}
        <Row className="mb-5">
          {filteredProducts.map(product => (
            <Col key={product.id} xs={12} sm={6} lg={3} className="mb-4">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Img 
                  variant="top" 
                  src={product.image} 
                  alt={product.name} 
                  style={{ height: '200px', objectFit: 'cover' }}
                />
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="text-dark font-weight-bold">
                    {product.name}
                  </Card.Title>
                  <Card.Text className="text-muted small mb-3">
                    {product.description.length > 100 
                      ? product.description.substring(0, 100) + '...' 
                      : product.description}
                  </Card.Text>
                  
                  {/* Button to trigger the modal */}
                  <Button 
                    variant="danger" 
                    className="mt-auto" 
                    onClick={() => handleReadMore(product)} 
                  >
                    READ MORE
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
        
        {/* Fallback for no products in category */}
        {filteredProducts.length === 0 && (
            <h4 className="text-center text-muted my-5">
                No products found in the "{activeCategory}" category.
            </h4>
        )}
      </Container>
      
      {/* 5. Render the Modal Component when a product is selected */}
      {selectedProduct && <ProductModal />}
    </>
  );
};

export default ProductsPage;